import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './Popup.css';

function PopupMedia({ src, className = null }) {
  const [show, setShow] = useState(false);
  const onLoad = () => {
    setShow(true);
  }
  useEffect(() => {
    setShow(false);
  }, [src])

  return (
    <img alt={'popup_tip_media'} className={`popupv2-media ${!show && 'hide-media'} ${className && className} `} src={src} onLoad={onLoad} />
  )
}

PopupMedia.propTypes = {
  src: PropTypes.string.isRequired
}

export default PopupMedia;
